module.exports = __webpack_public_path__ + "static/media/serena.868b9d9b.png";